<template>
    <div class="mx-auto bg-gray-600 flex flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 gap-x-8">
        <NavLink v-for="r in routes" v-show="r.show" :href="r.route" :active="r.active">{{ r.name }}</NavLink>
    </div>
</template>

<script>
import NavLink from "@/Components/NavLink.vue";

export default {
    components: {
        NavLink,
    },
    data() {
        return {
            routes: [
                {
                    name: 'Пользователи',
                    route: this.route('dashboard.users'),
                    active: this.route().current('dashboard.users'),
                    show: this.access('dashboard', 'users'),
                },
                {
                    name: 'Авансовые балансы',
                    route: this.route('dashboard.advanced'),
                    active: this.route().current('dashboard.advanced'),
                    show: this.access('dashboard', 'advanced'),
                },
                {
                    name: 'Аналитика авансовых балансов',
                    route: this.route('dashboard.advanced.analytics'),
                    active: this.route().current('dashboard.advanced.analytics'),
                    show: this.access('dashboard', 'advanced_analytics'),
                },
                {
                    name: 'Пул адресов',
                    route: this.route('dashboard.addresses'),
                    active: this.route().current('dashboard.addresses'),
                    show: this.access('dashboard', 'addresses'),
                },
                {
                    name: 'Опер аккаунты',
                    route: this.route('dashboard.accounts'),
                    active: this.route().current('dashboard.accounts'),
                    show: this.access('dashboard', 'accounts'),
                },
            ],
        }
    },
}
</script>
